// Single source of truth for organization facts shown in header/footer.
// Update EIN / admin email / address here — they propagate site-wide.
export const ORG = {
  name: "RE//FORM PLACE CHI",
  legalName: "RE//FORM PLACE CHI",
  formerName: "Pivot Place CHI",
  tagline: "A Safe Place to Become. A Strong Place to Belong.",
  status: "501(‌c)(3) Nonprofit Organization",
  ein: "92-3112452",
  adminEmail: "info@reformplacechi.org",
  domain: "reformplacechi.org",
  url: "https://reformplacechi.org",
  email: "info@reformplacechi.org",
  giveEmail: "give@reformplacechi.org",
  phone: "(773) 940-5265",
  phoneHref: "tel:7739405265",
  address: {
    street: "1316 W. 63rd St",
    city: "Chicago",
    state: "IL",
    zip: "60636",
  },
  youtube: "https://www.youtube.com/@REFORMPlaceCHI",
};

export const ORG_ADDRESS_LINE = `${ORG.address.street}, ${ORG.address.city}, ${ORG.address.state} ${ORG.address.zip}`;
